import { render, staticRenderFns } from "./AddRelatedTransactionsViewer.vue?vue&type=template&id=ef8922a8&scoped=true&"
import script from "./AddRelatedTransactionsViewer.vue?vue&type=script&lang=js&"
export * from "./AddRelatedTransactionsViewer.vue?vue&type=script&lang=js&"
import style0 from "./AddRelatedTransactionsViewer.vue?vue&type=style&index=0&id=ef8922a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8922a8",
  null
  
)

export default component.exports